import { useState } from 'react';
import { Box } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Background from '../../assets/images/bg/collection_2026/star_bg_gray.png';
import Logo from '../../assets/images/logo/starcard_club_white.png';
import { useCartStore } from '../../stores/cartStore';
import { useUserStore } from '../../stores/userStore';
import Cart from '../cart/Cart';
import DialogInfo from '../feedback/DialogInfo';
import MenuBar from './MenuBar';

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const userInfo = useUserStore((state) => state.userInfo);
  const companyInfo = useUserStore((state) => state.companyInfo);
  const cart = useCartStore((state) => state.cart);

  const [dialogInfo, setDialogInfo] = useState(false);
  const [dialogState, setDialogState] = useState(false);

  const isOwner = companyInfo?.user_id._id === userInfo?._id;

  const handleShoppingCart = () => {
    if (companyInfo?.state !== 'ACCOUNT TERMINATE') {
      setDialogState(false);

      if (isOwner) {
        navigate('/cart');
      } else {
        setDialogInfo(true);
      }
    } else {
      setDialogState(true);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        position: 'relative',
        background: `url(${Background}) center center / cover, #FAFAFA`,
      }}
    >
      <Box
        id="header"
        component={'header'}
        sx={{
          width: '100%',
          height: '60px',
          backgroundColor: '#005972',
          padding: '0 10px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box component={'img'} src={Logo} alt="Starcard Club Logo" sx={{ height: '60px' }} />
        {isOwner && location.pathname.includes('/reward') && (
          <Box onClick={handleShoppingCart}>
            <Cart quantity={cart.length || 0} />
          </Box>
        )}
      </Box>

      <Box
        id="main"
        component={'main'}
        maxWidth="md"
        mx="auto"
        sx={{
          overflowX: 'hidden',
          overflowY: 'auto',
          width: '100%',
          height: 'calc(100vh - 130px)',
        }}
      >
        <Outlet />
      </Box>

      <MenuBar />

      <DialogInfo
        isOpen={dialogInfo}
        onClose={() => setDialogInfo(false)}
        text={`ไม่สามารถแลกของรางวัลได้\nเนื่องจากไม่มีสิทธิ์ในการแลก`}
        btnText="ปิด"
      />

      <DialogInfo
        isOpen={dialogState}
        onClose={() => setDialogState(false)}
        text={`กรุณาติดต่อ\nฝ่ายขายแผนกบัตร\nคาลเท็กซ์สตาร์การ์ด`}
        btnText="ปิด"
      />
    </Box>
  );
};
export default MainLayout;
